import palette from '../theme/palette';

const variants = [
  {
    props: { color: 'internal' },
    style: {
      '& .MuiFormControlLabel-label': {
        color: palette.internal.main,
      },
    },
  },
];

export default variants;
